export default "__VITE_ASSET__BEsMlOye__"